import { Component, OnInit } from '@angular/core'
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
import { MessageService } from 'primeng/api'
import { AuthService, UserService } from '../../../../api/services'
import { validateAllFormFields } from '../../../../formUtils'
import { CareFinitySession } from '../../../services/CareFinitySession'
import { CareFinityValidators } from '../../../validators/CareFinityValidators'
import { environment } from '../../../../../environments/environment'


@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css'],
})
export class ChangePasswordComponent implements OnInit {
  changePassword: UntypedFormGroup
  errorValidationSummary: string = ''
  ShowErrorSummary: boolean = false
  userName: string = ''
  logoutmsg: string = ''
  display: boolean = false
  private key: string
  displaypopup: boolean = false
    version: string = '';
  constructor(
    private fb: UntypedFormBuilder,
    private router: Router,
    private userService: UserService,
    private messageService: MessageService,
    private route: ActivatedRoute,
    private auth: AuthService,
  ) {}

  ngOnInit() {
      this.displaypopup = true
      this.version = environment.version;
    this.route.queryParams.subscribe((params) => {
      let data = params
      this.userName = data.u_Name
    })
    this.changePassword = this.fb.group({
      newPassword: ['', Validators.required],
      confirmPassword: ['', Validators.required],
    })

    this.changePassword.setValidators(
      CareFinityValidators.Match('newPassword', 'confirmPassword'),
    )
  }

  resetPassword(): void {
    validateAllFormFields(this.changePassword)
    if (this.changePassword.invalid) {
      return
    }

    this.userService
      .userResetForgotPassword({
        uName: this.userName,
        Password: this.changePassword.get('newPassword').value,
      })
      .subscribe((X) => {
        if (X.status.toLowerCase().indexOf('error') > -1) {
          this.ShowErrorSummary = true
          this.errorValidationSummary = X.message

          this.messageService.add({
            key: 'alertToast',
            severity: 'error',
            summary: 'ERROR',
            detail: X.message,
            life: 5000,
          })
        } else if (X.status.toLowerCase().indexOf('ok') > -1) {
          this.ShowErrorSummary = false

          this.logoutmsg =
            X.message + 'You will be redirected to the login page.'
          this.display = true

          return
        }
      })
  }

  logout() {
    CareFinitySession.logout(this.auth)
    this.router.navigate(['login'])
  }
}
